import React, { useEffect, useState } from "react";
import classes from "./ClinicsListMobile.module.css";

import ClinicCard from "./ClinicCard/ClinicCard";

import axios from "axios";

const ClinicsListMobile = (props) => {
  const [clinics, setClinics] = useState([]);

  useEffect(() => {
    axios
      .get("http://portal.lwah.org.lb:8080/PHPApis/ServListDoctorsAdv.php")
      .then((response) => {
        // console.log(response.data)
        setClinics(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <div className={classes.bigTitle}>
          العيادات المتخصصة
        </div>
        <div className={classes.info}>
          اضغط على الطبيب في العيادة المختصة لحجز موعد
        </div>
      </div>
      <div className={classes.list}>
      {
        (clinics.length > 0)?
            clinics.map((Clinic) => {
                if (Clinic.Doctors.length != 0){
                    return <ClinicCard Clinic={Clinic} key={Clinic.ServId} />;
                }
            })
        :<div className={classes.Loading}>
            Loading...
        </div>
        }
      </div>
    </div>
  );
};
export default ClinicsListMobile;
